module.exports = __webpack_public_path__ + "static/media/F8-React__Testing__Library.1a40aa83.png";